module.exports = __webpack_public_path__ + "images/花筑奢pr长图_04-5.jpg?v=61dbf71f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_04-5.jpg
 ** module id = 34
 ** module chunks = 1 2
 **/